module.exports = __webpack_public_path__ + "static/media/businessInsider.8e03aeac.png";